import { useSelector, useDispatch } from 'react-redux';
import { SectionHeader } from '../common/SharedComponents';
import { DrawTable } from '@apply/ui';
import { AdminRootState, inspectionActions } from '@apply/adminStore';
import { applicationInsights } from '../ApplicationInsights';
import { FeatureType } from '@apply/constants';
import InspectionsModal from '../inspections/InspectionsModal';

export function DrawSummary() {
    const featureList = useSelector((state: AdminRootState) => state.user.featureList);
    const drawState = useSelector((state: AdminRootState) => state.drawState);
    const { isOpen, drawBudgetId, set_drawBudget } = useSelector(
        (state: AdminRootState & { inspections: { inspectionsModal: { isOpen: boolean; drawBudgetId: number; set_drawBudget?: (v: unknown) => void } } }) =>
            state.inspections.inspectionsModal
    );
    const dispatch = useDispatch();
    const onClose = () => dispatch(inspectionActions.setInspectionsModal({ inspectionsModal: { isOpen: false } }) as never);

    const isFeatureEnabled = (featureId) => {
        if (!featureList) {
            return false;
        }
        const feature = featureList.find((f) => f.featureId === featureId);
        return feature?.isEnabled ?? false;
    };

    if (!isFeatureEnabled(FeatureType.Draws)) {
        return <h1 style={{ margin: 20 }}>Feature is currently turned off.</h1>;
    }

    return (
        <>
            <SectionHeader title='Draw Budget' />
            <div
                className='main-content bfi-draw'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <DrawTable
                    applicationInsights={applicationInsights}
                    borrowerName={''}
                    drawState={drawState}
                    isAdmin={true}
                    isInspectionsEnabled={isFeatureEnabled(FeatureType.Inspections)}
                />
            </div>
            <InspectionsModal
                isOpen={isOpen}
                drawBudgetId={drawBudgetId}
                set_drawBudget={set_drawBudget}
                onClose={onClose}
            />
        </>
    );
}
